import React from "react";
import {
    SovosButton,
    SovosToolbarActions,
    SovosToolbarColumn,
    SovosToolbarFilter,
    SovosToolbarGroup,
    SovosTypography,
} from "mosaic-react";
import { Visibility, VisibilityOff } from "mosaic-react-icons";
import { useGridApiContext, GridPreferencePanelsValue } from "@mui/x-data-grid";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { mappingToolbarPillButtonSx } from "./mappingToolbarStyles";

const MappingGridToolbar = ({ toolbarProps: tp, defaultToolbarProps }) => {
    const { i18n } = useGlobalValue();
    const {
        entityLabel,
        hasAiSuggestions,
        hideDoNotImport,
        onToggleHideDoNotImport,
        onToggleShowAiSuggestions,
        showAiSuggestions,
        showAiSuggestionToggle,
        showDoNotImportToggle,
    } = tp || {};
    const { filterArray, isPreferencesPanelOpen, isFilterPanelOpen } = defaultToolbarProps || {};
    const gridRef = useGridApiContext();

    const appliedFiltersCount = (filterArray || []).reduce(
        (count, item) => count + (item?.filters?.length || 0),
        0,
    );

    const toggleColumnPanel = () => {
        if (!isPreferencesPanelOpen) {
            gridRef.current.showPreferences(GridPreferencePanelsValue.columns);
        } else {
            gridRef.current.hidePreferences();
        }
    };

    const toggleFilterPanel = () => {
        if (!isFilterPanelOpen) {
            gridRef.current.showFilterPanel();
        } else {
            gridRef.current.hideFilterPanel();
        }
    };

    return (
        <SovosToolbarGroup sx={{ alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            {entityLabel && (
                <SovosTypography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
                    {i18n`You are mapping imported data to SAF-T ${entityLabel} data`}
                </SovosTypography>
            )}
            <SovosToolbarActions sx={{ alignItems: "center", display: "flex", gap: 1, marginLeft: "auto" }}>
                {showAiSuggestionToggle && hasAiSuggestions && (
                    <SovosButton
                        variant="outlined"
                        size="small"
                        onClick={onToggleShowAiSuggestions}
                        sx={mappingToolbarPillButtonSx}
                    >
                        {showAiSuggestions ? i18n`Hide AI Suggestion` : i18n`Show AI Suggestion`}
                    </SovosButton>
                )}
                {showDoNotImportToggle && (
                    <SovosButton
                        variant="outlined"
                        size="small"
                        startIcon={hideDoNotImport ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                        onClick={onToggleHideDoNotImport}
                        sx={mappingToolbarPillButtonSx}
                    >
                        {hideDoNotImport ? i18n`Show Do Not Import` : i18n`Hide Do Not Import`}
                    </SovosButton>
                )}
                <SovosToolbarColumn onClick={toggleColumnPanel} />
                <SovosToolbarFilter onClick={toggleFilterPanel} appliedFiltersCount={appliedFiltersCount} />
            </SovosToolbarActions>
        </SovosToolbarGroup>
    );
};

export default MappingGridToolbar;
